module.exports = __webpack_public_path__ + "img/logo-amaia.7431e7b.svg";